/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface AcquisIfapmeSearchDto
 */
export interface AcquisIfapmeSearchDto {
    /**
     * 
     * @type {TextSearch}
     * @memberof AcquisIfapmeSearchDto
     */
    description?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof AcquisIfapmeSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof AcquisIfapmeSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof AcquisIfapmeSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AcquisIfapmeSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof AcquisIfapmeSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AcquisIfapmeSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the AcquisIfapmeSearchDto interface.
 */
export function instanceOfAcquisIfapmeSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AcquisIfapmeSearchDtoFromJSON(json: any): AcquisIfapmeSearchDto {
    return AcquisIfapmeSearchDtoFromJSONTyped(json, false);
}

export function AcquisIfapmeSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcquisIfapmeSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : TextSearchFromJSON(json['description']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function AcquisIfapmeSearchDtoToJSON(value?: AcquisIfapmeSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': TextSearchToJSON(value.description),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

